import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
const getToken = () => localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''
const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` })

const STATUS_MAP = {
  published: { bg: '#f6ffed', color: '#52c41a', text: '已发布' },
  draft: { bg: '#fffbe6', color: '#faad14', text: '草稿' },
  unpublished: { bg: '#fff1f0', color: '#ff4d4f', text: '已下架' },
}
const TYPE_OPTIONS = ['研学', '创演', '营地', '体验', '职业探索', 'AI创作', '夏令营', '生日派对', '其他']

function getStatusBadge(status) {
  const s = STATUS_MAP[status] || { bg: '#f5f5f5', color: '#999', text: status }
  return <span style={{ padding: '2px 10px', borderRadius: 12, fontSize: 12, color: s.color, background: s.bg }}>{s.text}</span>
}

const th = { padding: '12px 10px', textAlign: 'left', fontSize: 13, color: '#666', borderBottom: '1px solid #f0f0f0' }
const td = { padding: '12px 10px', fontSize: 13, borderBottom: '1px solid #f0f0f0' }
const btn = (bg, color = '#fff') => ({ padding: '5px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, background: bg, color })
const label = { display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '9px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }
const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalContent = { background: '#fff', borderRadius: 12, padding: 28, width: 640, maxHeight: '88vh', overflow: 'auto' }

function emptyForm() {
  return { title: '', type: '研学', activityDate: '', location: '', price: '', maxParticipants: '', ageRange: '', coverImage: '', description: '', highlights: '', base_id: '', enableOnlinePayment: false }
}

export default function StudyActivities() {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('list')
  const [showModal, setShowModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [form, setForm] = useState(emptyForm())
  const [selectedActivity, setSelectedActivity] = useState(null)
  const [signups, setSignups] = useState([])
  const [institutions, setInstitutions] = useState([])
  const [saving, setSaving] = useState(false)

  useEffect(() => { 
    loadActivities()
    loadInstitutions()
  }, [])

  const loadInstitutions = () => {
    fetch(`https://api.boxiaotu.cn/cms/api/institutions`, { headers: authHeaders() })
      .then(r => r.json())
      .then(d => { if (d.success) setInstitutions(d.data || []) })
      .catch(e => { console.error(e) })
  }

  const loadActivities = () => {
    setLoading(true)
    fetch(`${API}/study-activities`)
    fetch(`${API}/study-activities/admin/list`, { headers: authHeaders() })
      .then(r => r.json())
      .then(d => { if (d.success) setActivities(d.data || []) })
      .catch(e => { console.error(e) })
      .finally(() => setLoading(false))
  }

  const handleSubmit = async () => {
    if (!form.title || !form.date) { alert('请填写活动名称和日期'); return }
    try {
      const res = await fetch(`${API}/study-activities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) { setShowModal(false); setForm({ title: '', type: '职业探索', location: '', date: '', price: 0, capacity: 0, description: '' }); loadActivities() }
      else alert(data.error || '创建失败')
    } catch (e) { alert('创建失败') }
  const loadSignups = (activityId) => {
    fetch(`${API}/study-activities/${activityId}/registrations`, { headers: authHeaders() })
      .then(r => r.json())
      .then(d => { if (d.success) setSignups(d.data || []) })
      .catch(e => { console.error(e) })
  }

  const handleTab = (tab) => {
    setActiveTab(tab)
    if (tab === 'list') loadActivities()
  }

  const openCreate = () => {
    setEditId(null)
    setForm(emptyForm())
    setShowModal(true)
  }

  const openEdit = (a) => {
    setEditId(a.id)
    setForm({
      title: a.title || '',
      type: a.type || '研学',
      activityDate: a.activity_date || '',
      location: a.location || '',
      price: a.price || '',
      maxParticipants: a.max_participants || '',
      ageRange: a.age_range || '',
      coverImage: a.cover_image || '',
      description: a.description || '',
      highlights: a.highlights || '',
      base_id: a.base_id || '',
      enableOnlinePayment: a.enable_online_payment === 1 || a.enable_online_payment === '1'
    })
    setShowModal(true)
  }

  const handleSave = async () => {
    if (!form.title) { alert('请填写活动名称'); return }
    setSaving(true)
    try {
      const payload = {
        title: form.title,
        type: form.type,
        activityDate: form.activityDate,
        location: form.location,
        price: parseFloat(form.price) || 0,
        maxParticipants: parseInt(form.maxParticipants) || 50,
        ageRange: form.ageRange,
        coverImage: form.coverImage,
        description: form.description,
        highlights: form.highlights,
        base_id: form.base_id || undefined,
        enableOnlinePayment: form.enableOnlinePayment ? 1 : 0
      }
      const url = editId ? `${API}/study-activities/${editId}` : `${API}/study-activities`
      const method = editId ? 'PUT' : 'POST'
      const res = await fetch(url, { method, headers: authHeaders(), body: JSON.stringify(payload) })
      const data = await res.json()
      if (data.success) {
        setShowModal(false)
        loadActivities()
      } else {
        alert(data.error || '保存失败')
      }
    } catch (e) { alert('保存失败') }
    setSaving(false)
  }

  const handlePublish = async (id) => {
    if (!confirm('确认发布此活动？')) return
    const res = await fetch(`${API}/study-activities/${id}/publish`, { method: 'PUT', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '发布失败')
  }

  const handleUnpublish = async (id) => {
    if (!confirm('确认下架此活动？')) return
    const res = await fetch(`${API}/study-activities/${id}/unpublish`, { method: 'PUT', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '下架失败')
  }

  const handleDelete = async (id) => {
    if (!confirm('确认删除此活动？删除后不可恢复！')) return
    const res = await fetch(`${API}/study-activities/${id}`, { method: 'DELETE', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '删除失败')
  }

  const openSignupModal = (a) => {
    setSelectedActivity(a)
    setSignups([])
    loadSignups(a.id)
    setActiveTab('signups')
  }

  const handleSignupStatus = async (regId, status) => {
    const res = await fetch(`${API}/study-activities/registrations/${regId}`, {
      method: 'PUT', headers: authHeaders(), body: JSON.stringify({ status })
    })
    const data = await res.json()
    if (data.success && selectedActivity) loadSignups(selectedActivity.id)
    else alert(data.error || '更新失败')
  }

  const setField = (field, val) => setForm(f => ({ ...f, [field]: val }))

  const statCards = [
    { label: '全部活动', value: activities.length, color: '#1890ff' },
    { label: '已发布', value: activities.filter(a => a.status === 'published').length, color: '#52c41a' },
    { label: '草稿', value: activities.filter(a => a.status === 'draft').length, color: '#faad14' },
    { label: '总报名', value: activities.reduce((s, a) => s + (a.enrolled_count || 0), 0), color: '#722ed1' }
  ]

  return (
    <div style={{ padding: 24 }}>
      {/* 头部 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, margin: 0 }}>🎒 活动</h2>
          <p style={{ color: '#999', fontSize: 13, margin: '4px 0 0' }}>管理职业体验和研学项目，家长/小程序可见</p>
        </div>
        <button onClick={openCreate} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
          + 创建活动
        </button>
      </div>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
        {statCards.map((s, i) => (
          <div key={i} style={{ background: '#fff', borderRadius: 8, padding: '16px 20px', borderLeft: `4px solid ${s.color}` }}>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tab */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button onClick={() => handleTab('list')} style={{ padding: '8px 20px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, background: activeTab === 'list' ? '#1890ff' : '#f5f5f5', color: activeTab === 'list' ? '#fff' : '#666' }}>活动列表</button>
        <button onClick={() => handleTab('signups')} disabled={!selectedActivity} style={{ padding: '8px 20px', border: 'none', borderRadius: 6, cursor: selectedActivity ? 'pointer' : 'not-allowed', fontSize: 14, background: activeTab === 'signups' ? '#722ed1' : '#f5f5f5', color: activeTab === 'signups' ? '#fff' : '#999' }}>
          报名管理 {selectedActivity ? `(${signups.length})` : ''}
        </button>
      </div>

      {activeTab === 'list' ? (
        /* 活动列表 */
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div> :
           activities.length === 0 ? <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无活动，点击上方按钮创建</div> :
           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>
              <th style={th}>活动名称</th><th style={th}>类型</th><th style={th}>日期/地点</th>
              <th style={th}>价格</th><th style={th}>支付</th><th style={th}>报名/限额</th><th style={th}>状态</th>
              <th style={th}>操作</th>
            </tr></thead>
            <tbody>
              {activities.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontWeight: 500, maxWidth: 200 }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.title}</div>
                  </td>
                  <td style={td}><span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#e6f4ff', color: '#1890ff' }}>{a.type}</span></td>
                  <td style={{ ...td, color: '#666', fontSize: 12 }}>
                    <div>{a.activity_date || a.date || '-'}</div>
                    <div style={{ color: '#999' }}>{a.location || '-'}</div>
                  </td>
                  <td style={{ ...td, color: '#f5222d', fontWeight: 600 }}>{a.price > 0 ? `¥${a.price}` : '免费'}</td>
                  <td style={td}>{(a.enable_online_payment === 1 || a.enable_online_payment === '1')
                    ? <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#e6f4ff', color: '#1890ff' }}>线上</span>
                    : <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#f5f5f5', color: '#999' }}>线下</span>
                  }</td>
                  <td style={td}>
                    <span style={{ color: a.enrolled_count >= a.max_participants ? '#ff4d4f' : '#52c41a' }}>
                      {a.enrolled_count || 0}/{a.max_participants || 50}
                    </span>
                  </td>
                  <td style={td}>{getStatusBadge(a.status)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => openSignupModal(a)} style={{ ...btn('#722ed1'), marginRight: 4, color: '#fff' }}>报名</button>
                    <button onClick={() => openEdit(a)} style={{ ...btn('#1890ff'), color: '#fff', marginRight: 4 }}>编辑</button>
                    {a.status === 'published' || a.status === 'active'
                      ? <button onClick={() => handleUnpublish(a.id)} style={{ ...btn('#faad14'), marginRight: 4 }}>下架</button>
                      : <button onClick={() => handlePublish(a.id)} style={{ ...btn('#52c41a'), color: '#fff', marginRight: 4 }}>发布</button>
                    }
                    <button onClick={() => handleDelete(a.id)} style={{ ...btn('#ff4d4f'), color: '#fff' }}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>}
        </div>
      ) : (
        /* 报名管理 */
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          {selectedActivity && (
            <div style={{ marginBottom: 20 }}>
              <h3 style={{ margin: '0 0 4px', fontSize: 16 }}>{selectedActivity.title}</h3>
              <span style={{ fontSize: 13, color: '#999' }}>
                {selectedActivity.activity_date || selectedActivity.date} · {selectedActivity.location} · {signups.length}人报名
              </span>
            </div>
          )}
          {signups.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无报名记录</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ background: '#fafafa' }}>
                <th style={th}>孩子姓名</th><th style={th}>年龄</th><th style={th}>家长</th><th style={th}>电话</th><th style={th}>报名时间</th><th style={th}>状态</th><th style={th}>操作</th>
              </tr></thead>
              <tbody>
                {signups.map(s => (
                  <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={td}>{s.child_name}</td>
                    <td style={td}>{s.child_age || '-'}</td>
                    <td style={td}>{s.parent_name}</td>
                    <td style={{ ...td, color: '#1890ff' }}>{s.parent_phone}</td>
                    <td style={{ ...td, color: '#999', fontSize: 12 }}>{s.created_at ? new Date(s.created_at).toLocaleString('zh-CN') : '-'}</td>
                    <td style={td}>{getStatusBadge(s.status)}</td>
                    <td style={td}>
                      {s.status === 'pending' && (
                        <>
                          <button onClick={() => handleSignupStatus(s.id, 'confirmed')} style={{ ...btn('#52c41a'), color: '#fff', marginRight: 4 }}>确认</button>
                          <button onClick={() => handleSignupStatus(s.id, 'cancelled')} style={{ ...btn('#ff4d4f'), color: '#fff' }}>取消</button>
                        </>
                      )}
                      {s.status === 'confirmed' && (
                        <button onClick={() => handleSignupStatus(s.id, 'cancelled')} style={{ ...btn('#ff4d4f'), color: '#fff' }}>取消</button>
                      )}
                      {s.status === 'cancelled' && (
                        <span style={{ fontSize: 12, color: '#999' }}>-</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* 创建/编辑弹窗 */}
      {showModal && (
        <div style={modalOverlay} onClick={() => setShowModal(false)}>
          <div style={modalContent} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: 20, fontSize: 18 }}>{editId ? '编辑活动' : '创建活动'}</h3>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={label}>活动名称 *</label>
                <input value={form.title} onChange={e => setField('title', e.target.value)} placeholder="如：医生职业体验" style={input} />
              </div>
              <div>
                <label style={label}>活动类型</label>
                <select value={form.type} onChange={e => setField('type', e.target.value)} style={input}>
                  {TYPE_OPTIONS.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={label}>活动日期</label>
                <input type="date" value={form.activityDate} onChange={e => setField('activityDate', e.target.value)} style={input} />
              </div>
              <div>
                <label style={label}>活动地点</label>
                <input value={form.location} onChange={e => setField('location', e.target.value)} placeholder="如：水果山生态农场" style={input} />
              </div>
              <div>
                <label style={label}>举办机构</label>
                <select value={form.base_id} onChange={e => setField('base_id', e.target.value)} style={input}>
                  <option value="">请选择机构（基地/加盟店）</option>
                  {institutions.map(inst => (
                    <option key={inst.id} value={inst.id}>
                      {inst.name} {inst.type ? `(${inst.type})` : ''}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={label}>价格（元）</label>
                <input type="number" value={form.price} onChange={e => setField('price', e.target.value)} placeholder="0=免费" style={input} />
              </div>
              <div>
                <label style={label}>名额</label>
                <input type="number" value={form.maxParticipants} onChange={e => setField('maxParticipants', e.target.value)} placeholder="50" style={input} />
              </div>
              <div>
                <label style={label}>适合年龄</label>
                <input value={form.ageRange} onChange={e => setField('ageRange', e.target.value)} placeholder="如：4-12岁" style={input} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 24 }}>
                <input type="checkbox" id="enableOnlinePay" checked={form.enableOnlinePayment} onChange={e => setField('enableOnlinePayment', e.target.checked)} style={{ width: 18, height: 18, cursor: 'pointer' }} />
                <label htmlFor="enableOnlinePay" style={{ fontSize: 13, color: '#666', cursor: 'pointer' }}>启用线上支付</label>
                <span style={{ fontSize: 11, color: '#999' }}>（用户报名时直接微信支付）</span>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={label}>封面图片URL</label>
              <input value={form.coverImage} onChange={e => setField('coverImage', e.target.value)} placeholder="https://..." style={input} />
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={label}>活动介绍</label>
              <textarea value={form.description} onChange={e => setField('description', e.target.value)} rows={3} placeholder="活动详细介绍..." style={{ ...input, resize: 'vertical' }} />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={label}>活动亮点（多个用换行分隔）</label>
              <textarea value={form.highlights} onChange={e => setField('highlights', e.target.value)} rows={2} placeholder="专业导师全程陪伴\n动手实践，寓教于乐" style={{ ...input, resize: 'vertical' }} />
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={handleSave} disabled={saving} style={{ flex: 1, padding: 12, background: saving ? '#ccc' : '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: saving ? 'not-allowed' : 'pointer', fontSize: 15, fontWeight: 600 }}>
                {saving ? '保存中...' : (editId ? '保存修改' : '创建')}
              </button>
              <button onClick={() => setShowModal(false)} style={{ flex: 1, padding: 12, background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 15 }}>取消</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

}